import React, {Component} from 'react';
import "./Document.css"
import $ from "jquery";
import {OrganizationIcon, GraphIcon} from 'react-octicons'
import ReactSVG from 'react-svg';
import * as moment from 'moment'
import 'moment/locale/it'

import { NotificationManager} from 'react-notifications';

const Highlight = require('react-highlighter');
const Highcharts = require('highcharts');



class Document extends Component {
    chart = undefined
    chart_person = undefined

    constructor(props) {
        super(props);




        this.state =
            {
                title: "",
                abstract: "",
                text: "",
                searchText : ""

            }


        let title = ""
        let abstract = ""
        let text = ""
        let location = ""
        let data_doc = ""
        let collocation = ""
        let XaxisKey = []
        let serieDataKeys = []
        let XaxisEnt = []
        let serieDataEnt = []

        $.ajax({
            type: "POST",
            url: window.apiAlcideUrlPrefix + "loadFile",
            data: {
                "fileID": this.props.id,
                "corpus_id": "deg"
            },
            async: false,
            dataType: "json",
            success: function (data) {
                console.log(data);
                title = data.title;
                abstract = data.abstract;
                text = data.content;
                location = data.location;
                data_doc = data.date
                collocation = data.description
                XaxisKey = data.xAxis
                XaxisEnt = data.xAxisEnt
                serieDataKeys = data.seriesData
                serieDataEnt = data.seriesDataEnt

            }
        });
        if (title !== undefined) {
            this.state.title = title
            this.state.abstract = abstract
            this.state.text = text
            this.state.location = location
            this.state.date = data_doc.length === 8 ? data_doc.substr(0, 7) : data_doc
            this.state.collocation = collocation
            this.state.xAxisKey = XaxisKey
            this.state.seriesKey = serieDataKeys
            this.state.xAxisEnt = XaxisEnt
            this.state.seriesEnt = serieDataEnt
        }
    }

    pad(d) {
        return (d < 10) ? '0' + d.toString() : d.toString();
    }
    copyUrlToClipboard () {
        // Create new element
        console.log("copy");
        let el = document.createElement('textarea');
        // Set value (string to be copied)
        el.value = (window.apiAlcideUrlPrefix + "platform/?doc=" + this.props.id).replace("http://dh-server.fbk.eu:8080/Alcide/","http://alcidedigitale.fbk.eu/");
        // Set non-editable to avoid focus and move outside of view
        el.setAttribute('readonly', '');
        el.style = {position: 'absolute', left: '-9999px'};
        document.body.appendChild(el);
        // Select text inside element
        el.select();
        // Copy text to clipboard
        document.execCommand('copy');
        // Remove temporary element
        document.body.removeChild(el);
        NotificationManager.success('link copiato negli appunti',"",2000);
    }
    componentDidMount() {
        let widget = this;


        if (document.getElementById('chart_doc_keyword') !== null) {
            this.chart = Highcharts.chart(document.getElementById('chart_doc_keyword'), {
                credits: {
                    enabled: false
                },
                tooltip: {enabled: false},
                chart: {
                    backgroundColor: '#fff',
                    color: "#000000",
                    height: 500,
                    type: 'bar',
                    padding: "10px"
                },

                title: {
                    text: 'Parole Chiave',
                    style: {'color': '#000', 'font-family': 'monospace', 'font-size': '18px'}
                },
                yAxis: {
                    labels: {enabled: false},
                    gridLineColor: "transparent",
                    lineColor: "transparent",
                    title: null
                },
                xAxis: {
                    lineColor: "transparent",
                    gridLineColor: "transparent",
                    labels: {enabled: false},
                    tickColor: "transparent"

                },
                plotOptions: {
                    bar: {
                        stacking: 'normal',
                        color: "rgba(166,176,181,0.6)",
                        dataLabels: {
                            enabled: true,
                            align: 'left',
                            verticalAlign: 'middle',
                            color: '#000',
                            inside: true,
                            style: {

                                fontFamily: 'monospace',
                                textOutline: 0
                            },
                            formatter: function () {
                                if (this.point.isInside === true) {
                                    return '<span style="color: #000;font-weight: normal">' + "   " + this.x + '</span>';
                                } else {
                                    return '<span style="color: #000;font-weight: normal">' + "   " + this.x + '</span>';
                                }
                            }
                        },
                        shadow: false,
                        states: {
                            hover: {
                                color: 'rgba(0,0,0,0.3)'
                            }
                        },
                        // allowPointSelect : true,
                        point: {
                            events: {
                                click: function () {
                                    let cat = this.category
                                    //widget.props.callbackParent(cat);
                                }
                            }
                        }
                    },
                    series: {
                        pointPadding: 0,
                        groupPadding: 0.1,
                    }
                },
                series:
                    [{
                        showInLegend: false,
                        label: {enabled: true}
                    }]
            })


            this.chart_person = Highcharts.chart(document.getElementById('chart_doc_person'), {
                credits: {
                    enabled: false
                },
                tooltip: {enabled: false},
                chart: {
                    backgroundColor: '#fff',
                    color: "#000000",
                    height: 500,
                    type: 'bar',
                    padding: "10px"
                },

                title: {
                    text: 'Persone',
                    style: {'color': '#000', 'font-family': 'monospace', 'font-size': '18px'}
                },
                yAxis: {
                    labels: {enabled: false},
                    gridLineColor: "transparent",
                    lineColor: "transparent",
                    title: null
                },
                xAxis: {
                    lineColor: "transparent",
                    gridLineColor: "transparent",
                    labels: {enabled: false},
                    tickColor: "transparent"

                },
                plotOptions: {
                    bar: {
                        stacking: 'normal',
                        color: "rgba(166,176,181,0.6)",
                        dataLabels: {
                            enabled: true,
                            align: 'left',
                            verticalAlign: 'middle',
                            color: '#000',
                            inside: true,
                            style: {

                                fontFamily: 'monospace',
                                textOutline: 0
                            },
                            formatter: function () {
                                if (this.point.isInside === true) {
                                    return '<span style="color: #000;font-weight: normal">' + "   " + this.x + '</span>';
                                } else {
                                    return '<span style="color: #000;font-weight: normal">' + "   " + this.x + '</span>';
                                }
                            }
                        },
                        shadow: false,
                        states: {
                            hover: {
                                color: 'rgba(0,0,0,0.6)'
                            }
                        },
                        // allowPointSelect : true,
                        point: {
                            events: {
                                click: function () {
                                    let cat = this.category
                                    //widget.props.callbackParent(cat);
                                }
                            }
                        }
                    },
                    series: {
                        pointPadding: 0,
                        groupPadding: 0.15,
                    }
                },
                series:
                    [{
                        showInLegend: false,
                        label: {enabled: true}
                    }]
            })


            this.chart.xAxis[0].setCategories(this.state.xAxisKey)
            this.chart.series[0].setData(this.state.seriesKey);


            this.chart_person.xAxis[0].setCategories(this.state.xAxisEnt)
            this.chart_person.series[0].setData(this.state.seriesEnt);
        }
    }

    
    
    searchOnText(ev){

        let textToSearch = ev.target.value
        this.setState({searchText:textToSearch})

    }
    cleanField(e){
        e.preventDefault()
        e.stopPropagation()
        document.getElementById("searchText").value =""
        e.target.value = "";
        this.setState({searchText:""})
    }
    

    render() {


        if (this.state.title.length === 0) {
            return (<div/>)
        } else {
            moment.locale('it');
            let m = moment(this.state.date);
            let data = m.format('MMMM YYYY')

            if (this.state.date.replace('--', '').length === 4) {
                data = this.state.date.replace('--', '')
            } else if (this.state.date.split('-').length > 2) {


                let day = this.state.date.split('-')[2]

                data = this.state.date.split('-')[0] + "-" + this.state.date.split('-')[1] + "-" + this.pad(day)

                m = moment(data);
                data = m.format('LL')
            }


            return (
                <div>
                    <div className="col-header"><span>&nbsp;</span><i className="fa fa-search" style={{marginLeft: '8px', marginRight: '8px'}} onClick={() => {
                        document.getElementById("DocTextSearchBox").style.height === '0px' ? document.getElementById("DocTextSearchBox").style.height = '52px' : document.getElementById("DocTextSearchBox").style.height = '0px'
                        document.getElementById('searchText').focus();
                        document.getElementById('searchText').select();
                    }}/></div>
                    <div id="DocTextSearchBox" className="box" style={{width: "50%"}}>
                        <div className="container-4" style={{display: "flex"}}>
                            <input type="search" id="searchText" placeholder="Cerca nel testo..." onBlur={() => {
                                document.getElementById("DocTextSearchBox").style.height = '0px'
                            }} onChange={(e) => {
                                this.searchOnText(e)
                            }}/>



                            <button className="icon" onClick={(e) => {
                                this.cleanField(e)
                            }}><i className="fa fa-times-circle"/></button>
                        </div>
                    </div>
                    <div className="doc row">
                        <div className="col-md-10" style={{width: "100%"}}>
                            <div style={{width: "100%"}}>
                                <i className="fa fa-share-alt" title="Clicca per copiare l'indirizzo di riferimento" style={{float:"right",cursor:"pointer"}} onClick={() => {this.copyUrlToClipboard()}}/>
                                <h1>{this.state.title}</h1>
                                <h4 style={{fontStyle: 'italic'}}>{this.state.location + ", " + data}</h4>
                                <h4>{this.state.collocation}</h4>
                                <h4>{this.state.abstract}</h4>

                                <Highlight search={this.state.searchText}>{this.state.text}</Highlight>
                                {/*<p>{this.state.text}</p>*/}
                                <p>&nbsp;</p>
                                <div>
                                    <hr/>
                                </div>

                                {/*<div className="col-md-6"></div>*/}
                            </div>
                        </div>
                        <a name="bottomAnalyses"/>
                        <div className="col-md-5" style={{width: "50%"}}>
                            <div id="chart_doc_keyword" style={{marginLeft: '-2.7em', marginRight: '0'}}></div>
                        </div>
                        <div className="col-md-5" style={{width: "50%"}}>
                            <div id="chart_doc_person" style={{marginLeft: '-2.7em', marginRight: '-2.7em'}}></div>
                        </div>
                        <div className="col-md-1" id="doc_analyses" style={{display: "none"}}>
                        {/*<div className="col-md-1" id="doc_analyses" style={{width: "6.5%"}}>*/}
                            <a href="#bottomAnalyses">
                                <div className="analisysIcon">
                                    <img src={'img/keys.svg'}/>
                                    <p style={{fontSize: "0.67vmax", fontWeight: "bolder"}}>Parole chiave</p>
                                </div>
                            </a>
                            <a href="#bottomAnalyses">
                                <div className="analisysIcon">
                                    <img src={'img/prp.svg'}/>
                                    <p style={{fontSize: "0.67vmax", fontWeight: "bolder"}}>Persone</p>
                                </div>
                            </a>
                        </div>

                    </div>

                </div>
            )
        }
    }
}

export default Document;


// WEBPACK FOOTER //
// ./src/components/Document.jsx